import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuService } from './app.menu.service';
import { AppMainComponent } from './app.main.component';
import { UserDetailsService } from './esamui/service/userDetails.service';


@Component({
    /* tslint:disable:component-selector */
    selector: '[app-menuitem]',
    /* tslint:enable:component-selector */
    template: `
          <ng-container>
              <a [attr.href]="item.url" (click)="itemClick($event)" *ngIf="!item.routerLink || item.items" (mouseenter)="onMouseEnter()" (keydown.enter)="itemClick($event)"
                [attr.target]="item.target" [attr.tabindex]="0" pRipple>
                    <i [ngClass]="item.icon"></i>
                    <span style="width:350px !important">{{item.label}}</span>
                    <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
                    <span style="width:350px !important" class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
              </a>
              <a (click)="itemClick($event)" (mouseenter)="onMouseEnter()" *ngIf="item.routerLink && !item.items"
                  [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink" pRipple
                  [routerLinkActiveOptions]="{exact: true}" [attr.target]="item.target" [attr.tabindex]="0">
                  <i [ngClass]="item.icon"></i>
                    <span style="width:350px !important">{{item.label}}</span>
                    <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items">keyboard_arrow_down</i>
                    <span style="width:350px !important" class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
              </a>
              <ul style="width:350px !important" *ngIf="item.items && active" [@children]="(app.isHorizontal() && root) ? (active ? 'visible' : 'hidden') : (active ? 'visibleAnimated' : 'hiddenAnimated')">
                  <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
                      <li style="width:350px !important" app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass"></li>
                  </ng-template>
              </ul>
          </ng-container>
      `,
    host: {
        '[class.active-menuitem]': 'active'
    },
    animations: [
        trigger('children', [
            state('void', style({
                height: '0px'
            })),
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*',
                'z-index': 100
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('void => visibleAnimated, visibleAnimated => void',
                animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuitemComponent implements OnInit, OnDestroy {

    @Input() item: any;

    @Input() index: number;

    @Input() root: boolean;

    @Input() parentKey: string;

    active = false;

    menuSourceSubscription: Subscription;

    menuResetSubscription: Subscription;

    key: string;

    userId: string;
    userDetail: any;
    userRole: any;
    intUserId:string;
    //constructor(public app: AppMainComponent, public router: Router, private menuService: MenuService) {

  constructor(private userDetailsService: UserDetailsService, public app: AppMainComponent,
       public router: Router, private menuService: MenuService) {

           this.menuSourceSubscription = this.menuService.menuSource$.subscribe(key => {
            // deactivate current active menu
            if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
                this.active = false;
            }
        });

        this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
            this.active = false;
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(params => {
                if (this.app.isHorizontal()) {
                    this.active = false;
                } else {
                    if (this.item.routerLink) {
                        this.updateActiveStateFromRoute();
                    } else {
                        this.active = false;
                    }
                }
            });
    }

    ngOnInit() {
        this.intUserId = localStorage.getItem('uid').toUpperCase();
        this.userId = localStorage.getItem('firstName').toUpperCase() + '.' + localStorage.getItem('surname').toUpperCase();
        if(this.userId != this.intUserId) {
            this.userId= this.intUserId;
        }
    
     
        console.log("This is logon user Id ="+this.userId);
        if (!this.app.isHorizontal() && this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }

        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);

        this.userDetailsService.getUserIntuserId(this.userId)
            .subscribe(data => {
                this.userDetail = data;
                this.userRole = this.userDetail.roleId;
                if (this.userRole == 'ACO' || this.userRole == 'READ_ONLY') {
                    // 2
                    this.updateMenuItem('Email Template');
                    this.updateMenuItem('Manage User Details');
                    this.updateMenuItem('Portal');
                    this.updateMenuItem('NQAITS ASR Data Update');
                    this.updateMenuItem('Management Report');                    
                    this.updateMenuItem('Service Context Expiry Date Maintenance');
                    this.updateMenuItem('Service & Provider Details');                    
                    this.updateMenuItem('Service Feedback Expiry Date Maintenance');
                    this.updateMenuItem('Survey Expiry Date Maintenance');
                    this.updateMenuItem('TRIM Operation');
                    this.updateMenuItem('QIP and SCF Notification Reminder Operation');
                    this.updateMenuItem('Survey Details');
                    this.updateMenuItem('WWCC Reports');
                    this.updateMenuItem('Portal Data Maintenance');
                } else if (this.userRole == 'ROM') {
                    // 2,6,8
                    this.updateMenuItem('Email Template');
                    this.updateMenuItem('Manage User Details');
                    this.updateMenuItem('Portal');
                    this.updateMenuItem('NQAITS ASR Data Update');
                    this.updateMenuItem('TRIM Operation');
                    this.updateMenuItem('Service Context Expiry Date Maintenance');
                    this.updateMenuItem('Service & Provider Details');
                    this.updateMenuItem('Service Feedback Expiry Date Maintenance');
                    this.updateMenuItem('Survey Expiry Date Maintenance');
                    this.updateMenuItem('QIP and SCF Notification Reminder Operation');
                    this.updateMenuItem('WWCC Reports');
                    this.updateMenuItem('Portal Data Maintenance');
                }

                //console.log("this is roleId >> " + this.userDetail.roleId);
            });
    }

    updateMenuItem(key: string) {

        if (this.item.items) {
            this.item.items.forEach((value, index) => {
                if (value.label == key) this.item.items.splice(index, 1);
            });
        }
    }   
     updateActiveStateFromRoute() {
        this.active = this.router.isActive(this.item.routerLink[0], this.item.items ? false : true);
    }

    itemClick(event: Event) {
        // avoid processing disabled items
        if (this.item.disabled) {
            event.preventDefault();
            return true;
        }

        // navigate with hover in horizontal mode
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // notify other items
        this.menuService.onMenuStateChange(this.key);

        // execute command
        if (this.item.command) {
            this.item.command({ originalEvent: event, item: this.item });
        }

        // toggle active state
        if (this.item.items) {
            this.active = !this.active;
        } else {
            // activate item
            this.active = true;

            // hide overlay menus
            if (this.app.isMobile()) {
                this.app.sidebarActive = false;
                this.app.mobileMenuActive = false;
            }

            // reset horizontal menu
            if (this.app.isHorizontal()) {
                this.menuService.reset();
            }
        }
    }

    onMouseEnter() {
        // activate item on hover
        if (this.root && this.app.menuHoverActive && this.app.isHorizontal() && this.app.isDesktop()) {
            this.menuService.onMenuStateChange(this.key);
            this.active = true;
        }
    }

    ngOnDestroy(){
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }

        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
}
